import { __awaiter } from "tslib";
import { addProp, body } from "@pnp/odata";
import { GraphRest } from "../rest";
import { _Group, Group } from "../groups/types";
import { Team, Teams } from "./types";
import { graphPut } from "../operations";
import "./users";
export { Channel, Channels, Tab, Tabs, Team, Teams, } from "./types.js";
addProp(_Group, "team", Team);
_Group.prototype.createTeam = function (props) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield graphPut(this.clone(Group, "team"), body(props));
        return {
            data,
            team: this.team,
        };
    });
};
Reflect.defineProperty(GraphRest.prototype, "teams", {
    configurable: true,
    enumerable: true,
    get: function () {
        return this.childConfigHook(({ options, baseUrl, runtime }) => {
            return Teams(baseUrl).configure(options).setRuntime(runtime);
        });
    },
});
//# sourceMappingURL=index.js.map